/**
 * A Font Awesome icon, drawn from its definition as one inline `<svg>`. Import each icon by name
 * from `@fortawesome/free-solid-svg-icons` (the package is side-effect free, so the build keeps only
 * the icons imported). This renders the definition directly instead of going through
 * `@fortawesome/fontawesome-svg-core` and `react-fontawesome`: those add a runtime library and inject
 * a stylesheet at boot, and a solid icon is a single path.
 *
 * The icon is `1em` square and takes `currentColor`, so it sizes with `font-size` and colours with
 * `color` like the glyphs it replaces. It is decoration: the host control carries the name
 * (`aria-label`), and a `data-tip` (`lib/tooltip.ts`) says what it does.
 */
import type { IconDefinition } from "@fortawesome/free-solid-svg-icons";

export function Icon({ icon, className }: { icon: IconDefinition; className?: string }) {
  const [width, height, , , path] = icon.icon;
  return (
    <svg className={className ? `icon ${className}` : "icon"} viewBox={`0 0 ${width} ${height}`} aria-hidden="true" focusable="false" data-icon={icon.iconName}>
      <path fill="currentColor" d={typeof path === "string" ? path : path.join(" ")} />
    </svg>
  );
}
